import React, { ComponentType, forwardRef, Ref } from 'react';
import { InputAttributes, NumericFormat, NumericFormatProps } from 'react-number-format';

import { Input } from '@ast/magma/components/input';

export const NumericInput = forwardRef((props: NumericFormatProps & {label?: string | null},
  ref: Ref<NumericFormatProps>) => (
    <NumericFormat
      getInputRef={ref}
      inputMode="numeric"
      customInput={Input as ComponentType<InputAttributes> | undefined}
      allowLeadingZeros
      allowNegative={false}
      decimalScale={0}
      {...props}
    />
));

NumericInput.defaultProps = {
  label: '',
};
